"use strict";
/**
 * AUTOGENERATED
 *
 * DO NOT MODIFY
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CN = void 0;
exports.CN = {
    numericCode: '156',
    alpha2Code: 'CN',
    alpha3Code: 'CHN',
    englishName: {
        short: 'China',
        full: "the People's Republic of China",
    },
    names: {
        full: {
            en: "the People's Republic of China",
            fr: 'la République populaire de Chine',
            zh: 'Zhongguo',
        },
        short: {
            en: 'China',
            fr: 'Chine (la)',
            zh: 'Zhongguo',
        },
    },
    languages: [
        {
            languageAlpha2Code: 'en',
            languageAlpha3Code: 'eng',
            isAdministrative: false,
        },
        {
            languageAlpha2Code: 'fr',
            languageAlpha3Code: 'fra',
            isAdministrative: false,
        },
        {
            languageAlpha2Code: 'zh',
            languageAlpha3Code: 'zho',
            isAdministrative: true,
        },
    ],
    subdivisions: {
        'CN-AH': {
            numericCode: '156',
            code: 'CN-AH',
            category: {
                id: '103',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    zh: {
                        singular: 'sheng',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                zh: 'Anhui Sheng',
            },
        },
        'CN-FJ': {
            numericCode: '156',
            code: 'CN-FJ',
            category: {
                id: '103',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    zh: {
                        singular: 'sheng',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                zh: 'Fujian Sheng',
            },
        },
        'CN-GD': {
            numericCode: '156',
            code: 'CN-GD',
            category: {
                id: '103',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    zh: {
                        singular: 'sheng',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                zh: 'Guangdong Sheng',
            },
        },
        'CN-GS': {
            numericCode: '156',
            code: 'CN-GS',
            category: {
                id: '103',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    zh: {
                        singular: 'sheng',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                zh: 'Gansu Sheng',
            },
        },
        'CN-GZ': {
            numericCode: '156',
            code: 'CN-GZ',
            category: {
                id: '103',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    zh: {
                        singular: 'sheng',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                zh: 'Guizhou Sheng',
            },
        },
        'CN-HA': {
            numericCode: '156',
            code: 'CN-HA',
            category: {
                id: '103',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    zh: {
                        singular: 'sheng',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                zh: 'Henan Sheng',
            },
        },
        'CN-HB': {
            numericCode: '156',
            code: 'CN-HB',
            category: {
                id: '103',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    zh: {
                        singular: 'sheng',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                zh: 'Hubei Sheng',
            },
        },
        'CN-HE': {
            numericCode: '156',
            code: 'CN-HE',
            category: {
                id: '103',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    zh: {
                        singular: 'sheng',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                zh: 'Hebei Sheng',
            },
        },
        'CN-HI': {
            numericCode: '156',
            code: 'CN-HI',
            category: {
                id: '103',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    zh: {
                        singular: 'sheng',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                zh: 'Hainan Sheng',
            },
        },
        'CN-HL': {
            numericCode: '156',
            code: 'CN-HL',
            category: {
                id: '103',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    zh: {
                        singular: 'sheng',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                zh: 'Heilongjiang Sheng',
            },
        },
        'CN-HN': {
            numericCode: '156',
            code: 'CN-HN',
            category: {
                id: '103',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    zh: {
                        singular: 'sheng',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                zh: 'Hunan Sheng',
            },
        },
        'CN-JL': {
            numericCode: '156',
            code: 'CN-JL',
            category: {
                id: '103',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    zh: {
                        singular: 'sheng',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                zh: 'Jilin Sheng',
            },
        },
        'CN-JS': {
            numericCode: '156',
            code: 'CN-JS',
            category: {
                id: '103',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    zh: {
                        singular: 'sheng',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                zh: 'Jiangsu Sheng',
            },
        },
        'CN-JX': {
            numericCode: '156',
            code: 'CN-JX',
            category: {
                id: '103',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    zh: {
                        singular: 'sheng',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                zh: 'Jiangxi Sheng',
            },
        },
        'CN-LN': {
            numericCode: '156',
            code: 'CN-LN',
            category: {
                id: '103',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    zh: {
                        singular: 'sheng',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                zh: 'Liaoning Sheng',
            },
        },
        'CN-QH': {
            numericCode: '156',
            code: 'CN-QH',
            category: {
                id: '103',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    zh: {
                        singular: 'sheng',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                zh: 'Qinghai Sheng',
            },
        },
        'CN-SC': {
            numericCode: '156',
            code: 'CN-SC',
            category: {
                id: '103',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    zh: {
                        singular: 'sheng',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                zh: 'Sichuan Sheng',
            },
        },
        'CN-SD': {
            numericCode: '156',
            code: 'CN-SD',
            category: {
                id: '103',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    zh: {
                        singular: 'sheng',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                zh: 'Shandong Sheng',
            },
        },
        'CN-SN': {
            numericCode: '156',
            code: 'CN-SN',
            category: {
                id: '103',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    zh: {
                        singular: 'sheng',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                zh: 'Shaanxi Sheng',
            },
        },
        'CN-SX': {
            numericCode: '156',
            code: 'CN-SX',
            category: {
                id: '103',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    zh: {
                        singular: 'sheng',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                zh: 'Shanxi Sheng',
            },
        },
        'CN-TW': {
            numericCode: '156',
            code: 'CN-TW',
            category: {
                id: '103',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    zh: {
                        singular: 'sheng',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                zh: 'Taiwan Sheng (see also separate country code entry under TW)',
            },
        },
        'CN-YN': {
            numericCode: '156',
            code: 'CN-YN',
            category: {
                id: '103',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    zh: {
                        singular: 'sheng',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                zh: 'Yunnan Sheng',
            },
        },
        'CN-ZJ': {
            numericCode: '156',
            code: 'CN-ZJ',
            category: {
                id: '103',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    zh: {
                        singular: 'sheng',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                zh: 'Zhejiang Sheng',
            },
        },
        'CN-GX': {
            numericCode: '156',
            code: 'CN-GX',
            category: {
                id: '195',
                names: {
                    en: {
                        singular: 'autonomous region',
                        plural: 'autonomous regions',
                    },
                    fr: {
                        singular: 'région autonome',
                        plural: '',
                    },
                    zh: {
                        singular: 'zizhiqu',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                zh: 'Guangxi Zhuangzu Zizhiqu',
            },
        },
        'CN-NM': {
            numericCode: '156',
            code: 'CN-NM',
            category: {
                id: '195',
                names: {
                    en: {
                        singular: 'autonomous region',
                        plural: 'autonomous regions',
                    },
                    fr: {
                        singular: 'région autonome',
                        plural: '',
                    },
                    zh: {
                        singular: 'zizhiqu',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                zh: 'Nei Mongol Zizhiqu',
            },
        },
        'CN-NX': {
            numericCode: '156',
            code: 'CN-NX',
            category: {
                id: '195',
                names: {
                    en: {
                        singular: 'autonomous region',
                        plural: 'autonomous regions',
                    },
                    fr: {
                        singular: 'région autonome',
                        plural: '',
                    },
                    zh: {
                        singular: 'zizhiqu',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                zh: 'Ningxia Huizu Zizhiqu',
            },
        },
        'CN-XJ': {
            numericCode: '156',
            code: 'CN-XJ',
            category: {
                id: '195',
                names: {
                    en: {
                        singular: 'autonomous region',
                        plural: 'autonomous regions',
                    },
                    fr: {
                        singular: 'région autonome',
                        plural: '',
                    },
                    zh: {
                        singular: 'zizhiqu',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                zh: 'Xinjiang Uygur Zizhiqu',
            },
        },
        'CN-XZ': {
            numericCode: '156',
            code: 'CN-XZ',
            category: {
                id: '195',
                names: {
                    en: {
                        singular: 'autonomous region',
                        plural: 'autonomous regions',
                    },
                    fr: {
                        singular: 'région autonome',
                        plural: '',
                    },
                    zh: {
                        singular: 'zizhiqu',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                zh: 'Xizang Zizhiqu',
            },
        },
        'CN-HK': {
            numericCode: '156',
            code: 'CN-HK',
            category: {
                id: '268',
                names: {
                    en: {
                        singular: 'special administrative region',
                        plural: 'special administrative regions',
                    },
                    fr: {
                        singular: 'région administrative spéciale',
                        plural: '',
                    },
                    zh: {
                        singular: 'tebie xingzhengqu',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Hong Kong SAR (see also separate country code entry under HK)',
                zh: 'Xianggang Tebiexingzhengqu (see also separate country code entry under HK)',
            },
        },
        'CN-MO': {
            numericCode: '156',
            code: 'CN-MO',
            category: {
                id: '268',
                names: {
                    en: {
                        singular: 'special administrative region',
                        plural: 'special administrative regions',
                    },
                    fr: {
                        singular: 'région administrative spéciale',
                        plural: '',
                    },
                    zh: {
                        singular: 'tebie xingzhengqu',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Macao SAR (see also separate country code entry under MO)',
                pt: 'Macau SAR (see also separate country code entry under MO)',
                zh: 'Aomen Tebiexingzhengqu (see also separate country code entry under MO)',
            },
        },
        'CN-BJ': {
            numericCode: '156',
            code: 'CN-BJ',
            category: {
                id: '397',
                names: {
                    en: {
                        singular: 'municipality',
                        plural: 'municipalities',
                    },
                    fr: {
                        singular: 'municipalité',
                        plural: '',
                    },
                    zh: {
                        singular: 'shi',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                zh: 'Beijing Shi',
            },
        },
        'CN-CQ': {
            numericCode: '156',
            code: 'CN-CQ',
            category: {
                id: '397',
                names: {
                    en: {
                        singular: 'municipality',
                        plural: 'municipalities',
                    },
                    fr: {
                        singular: 'municipalité',
                        plural: '',
                    },
                    zh: {
                        singular: 'shi',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                zh: 'Chongqing Shi',
            },
        },
        'CN-SH': {
            numericCode: '156',
            code: 'CN-SH',
            category: {
                id: '397',
                names: {
                    en: {
                        singular: 'municipality',
                        plural: 'municipalities',
                    },
                    fr: {
                        singular: 'municipalité',
                        plural: '',
                    },
                    zh: {
                        singular: 'shi',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                zh: 'Shanghai Shi',
            },
        },
        'CN-TJ': {
            numericCode: '156',
            code: 'CN-TJ',
            category: {
                id: '397',
                names: {
                    en: {
                        singular: 'municipality',
                        plural: 'municipalities',
                    },
                    fr: {
                        singular: 'municipalité',
                        plural: '',
                    },
                    zh: {
                        singular: 'shi',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                zh: 'Tianjin Shi',
            },
        },
    },
    cities: [
        {
            name: 'Rikaze',
            subdivision: 'Tibet Autonomous Region',
        },
        {
            name: 'Jiuquan',
            subdivision: 'Gansu Sheng',
        },
        {
            name: 'Shache',
            subdivision: 'Xinjiang Uygur Zizhiqu',
        },
        {
            name: 'Qamdo',
            subdivision: 'Tibet Autonomous Region',
        },
        {
            name: 'Nagqu',
            subdivision: 'Tibet Autonomous Region',
        },
        {
            name: 'Lhasa',
            subdivision: 'Tibet Autonomous Region',
        },
        {
            name: 'Laojunmiao',
            subdivision: 'Gansu Sheng',
        },
        {
            name: 'Kashgar',
            subdivision: 'Xinjiang Uygur Zizhiqu',
        },
        {
            name: 'Jiayuguan',
            subdivision: 'Gansu Sheng',
        },
        {
            name: 'Hotan',
            subdivision: 'Xinjiang Uygur Zizhiqu',
        },
        {
            name: 'Dêqên',
            subdivision: 'Tibet Autonomous Region',
        },
        {
            name: 'Ürümqi',
            subdivision: 'Xinjiang Uygur Zizhiqu',
        },
        {
            name: 'Laochenglu',
            subdivision: 'Xinjiang Uygur Zizhiqu',
        },
        {
            name: 'Shihezi',
            subdivision: 'Xinjiang Uygur Zizhiqu',
        },
        {
            name: 'Kuche',
            subdivision: 'Xinjiang Uygur Zizhiqu',
        },
        {
            name: 'Sayibage',
            subdivision: 'Xinjiang Uygur Zizhiqu',
        },
        {
            name: 'Hoxtolgay',
            subdivision: 'Xinjiang Uygur Zizhiqu',
        },
        {
            name: 'Hami',
            subdivision: 'Xinjiang Uygur Zizhiqu',
        },
        {
            name: 'Changji',
            subdivision: 'Xinjiang Uygur Zizhiqu',
        },
        {
            name: 'Baijiantan',
            subdivision: 'Xinjiang Uygur Zizhiqu',
        },
        {
            name: 'Aral',
            subdivision: 'Xinjiang Uygur Zizhiqu',
        },
        {
            name: 'Altay',
            subdivision: 'Xinjiang Uygur Zizhiqu',
        },
        {
            name: 'Yingbazha',
            subdivision: 'Xinjiang Uygur Zizhiqu',
        },
        {
            name: 'Zunyi',
            subdivision: 'Guizhou Sheng',
        },
        {
            name: 'Zoucheng',
            subdivision: 'Shandong Sheng',
        },
        {
            name: 'Yanjiang',
            subdivision: 'Sichuan',
        },
        {
            name: 'Zigong',
            subdivision: 'Sichuan',
        },
        {
            name: 'Zhuzhou',
            subdivision: 'Hunan',
        },
        {
            name: 'Zhumadian',
            subdivision: 'Henan Sheng',
        },
        {
            name: 'Zhujiajiao',
            subdivision: 'Shanghai Shi',
        },
        {
            name: 'Shangqiu',
            subdivision: 'Henan Sheng',
        },
        {
            name: 'Zhuji',
            subdivision: 'Zhejiang Sheng',
        },
        {
            name: 'Mizhou',
            subdivision: 'Shandong Sheng',
        },
        {
            name: 'Zhuanghe',
            subdivision: 'Liaoning',
        },
        {
            name: 'Zhouzhuang',
            subdivision: 'Jiangsu',
        },
        {
            name: 'Zhoukou',
            subdivision: 'Henan Sheng',
        },
        {
            name: 'Zhoucun',
            subdivision: 'Shandong Sheng',
        },
        {
            name: 'Yuxi',
            subdivision: 'Yunnan',
        },
        {
            name: 'Zhongxing',
            subdivision: 'Jiangsu',
        },
        {
            name: 'Zhongshu',
            subdivision: 'Yunnan',
        },
        {
            name: 'Zhicheng',
            subdivision: 'Zhejiang Sheng',
        },
        {
            name: 'Zhicheng',
            subdivision: 'Hubei',
        },
        {
            name: 'Zhenzhou',
            subdivision: 'Jiangsu',
        },
        {
            name: 'Zhenjiang',
            subdivision: 'Jiangsu',
        },
        {
            name: 'Zhaobaoshan',
            subdivision: 'Zhejiang Sheng',
        },
        {
            name: 'Zhengzhou',
            subdivision: 'Henan Sheng',
        },
        {
            name: 'Xinghua',
            subdivision: 'Jiangsu',
        },
        {
            name: 'Zhaotong',
            subdivision: 'Yunnan',
        },
        {
            name: 'Zhaoqing',
            subdivision: 'Guangdong',
        },
        {
            name: 'Zhaogezhuang',
            subdivision: 'Hebei',
        },
        {
            name: 'Luofeng',
            subdivision: 'Shandong Sheng',
        },
        {
            name: 'Zhanjiang',
            subdivision: 'Guangdong',
        },
        {
            name: 'Zhangzhou',
            subdivision: 'Fujian',
        },
        {
            name: 'Zhangye',
            subdivision: 'Gansu Sheng',
        },
        {
            name: 'Zibo',
            subdivision: 'Shandong Sheng',
        },
        {
            name: 'Anyang',
            subdivision: 'Henan Sheng',
        },
        {
            name: 'Zaozhuang',
            subdivision: 'Shandong Sheng',
        },
        {
            name: 'Zaoyang',
            subdivision: 'Hubei',
        },
        {
            name: 'Yuyao',
            subdivision: 'Zhejiang Sheng',
        },
        {
            name: 'Yingchuan',
            subdivision: 'Henan Sheng',
        },
        {
            name: 'Yuxia',
            subdivision: 'Shaanxi',
        },
        {
            name: 'Kunshan',
            subdivision: 'Jiangsu',
        },
        {
            name: 'Yunyang',
            subdivision: 'Henan Sheng',
        },
        {
            name: 'Yunmeng Chengguanzhen',
            subdivision: 'Hubei',
        },
        {
            name: 'Jinghong',
            subdivision: 'Yunnan',
        },
        {
            name: 'Pizhou',
            subdivision: 'Jiangsu',
        },
        {
            name: 'Yunfu',
            subdivision: 'Guangdong',
        },
        {
            name: 'Yuncheng',
            subdivision: 'Shanxi Sheng',
        },
        {
            name: 'Yulin',
            subdivision: 'Shaanxi',
        },
        {
            name: 'Yulin',
            subdivision: 'Guangxi Zhuangzu Zizhiqu',
        },
        {
            name: 'Yudong',
            subdivision: 'Chongqing Shi',
        },
        {
            name: 'Yuci',
            subdivision: 'Shanxi Sheng',
        },
        {
            name: 'Yucheng',
            subdivision: 'Shandong Sheng',
        },
        {
            name: 'Yuanping',
            subdivision: 'Shanxi Sheng',
        },
        {
            name: 'Qianjiang',
            subdivision: 'Hubei',
        },
        {
            name: 'Heyuan',
            subdivision: 'Guangdong',
        },
        {
            name: 'Yongfeng',
            subdivision: 'Hunan',
        },
        {
            name: 'Yongchuan',
            subdivision: 'Chongqing Shi',
        },
        {
            name: 'Yishui',
            subdivision: 'Shandong Sheng',
        },
        {
            name: 'Zhongxiang',
            subdivision: 'Hubei',
        },
        {
            name: 'Yingshang Chengguanzhen',
            subdivision: 'Anhui Sheng',
        },
        {
            name: 'Chengzhong',
            subdivision: 'Hubei',
        },
        {
            name: 'Yinchuan',
            subdivision: 'Ningxia Huizu Zizhiqu',
        },
        {
            name: 'Yima',
            subdivision: 'Henan Sheng',
        },
        {
            name: 'Yigou',
            subdivision: 'Henan Sheng',
        },
        {
            name: 'Qingzhou',
            subdivision: 'Shandong Sheng',
        },
        {
            name: 'Yichun',
            subdivision: 'Jiangxi Sheng',
        },
        {
            name: 'Yicheng',
            subdivision: 'Hubei',
        },
        {
            name: 'Yicheng',
            subdivision: 'Jiangsu',
        },
        {
            name: 'Yichang',
            subdivision: 'Hubei',
        },
        {
            name: 'Yibin',
            subdivision: 'Sichuan',
        },
        {
            name: 'Yatou',
            subdivision: 'Shandong Sheng',
        },
        {
            name: 'Yashan',
            subdivision: 'Guangxi Zhuangzu Zizhiqu',
        },
        {
            name: 'Yanzhou',
            subdivision: 'Shandong Sheng',
        },
        {
            name: 'Yantai',
            subdivision: 'Shandong Sheng',
        },
        {
            name: 'Yanliang',
            subdivision: 'Shaanxi',
        },
        {
            name: 'Yangzhou',
            subdivision: 'Jiangsu',
        },
        {
            name: 'Yangshuo',
            subdivision: 'Guangxi Zhuangzu Zizhiqu',
        },
        {
            name: 'Zhangjiagang',
            subdivision: 'Jiangsu',
        },
        {
            name: 'Yangquan',
            subdivision: 'Shanxi Sheng',
        },
        {
            name: 'Yangliuqing',
            subdivision: 'Tianjin Shi',
        },
        {
            name: 'Yanggu',
            subdivision: 'Shandong Sheng',
        },
        {
            name: 'Yangcun',
            subdivision: 'Tianjin Shi',
        },
        {
            name: 'Yancheng',
            subdivision: 'Jiangsu',
        },
        {
            name: 'Tongshan',
            subdivision: 'Jiangsu',
        },
        {
            name: 'Xucheng',
            subdivision: 'Guangdong',
        },
        {
            name: 'Shangrao',
            subdivision: 'Jiangxi Sheng',
        },
        {
            name: 'Xunchang',
            subdivision: 'Sichuan',
        },
        {
            name: 'Jiangguanchi',
            subdivision: 'Henan Sheng',
        },
        {
            name: 'Xuanzhou',
            subdivision: 'Anhui Sheng',
        },
        {
            name: 'Xixiang',
            subdivision: 'Henan Sheng',
        },
        {
            name: 'Xiuying',
            subdivision: 'Hainan',
        },
        {
            name: 'Xiulin',
            subdivision: 'Hubei',
        },
        {
            name: 'Xiongzhou',
            subdivision: 'Guangdong',
        },
        {
            name: 'Guixi',
            subdivision: 'Jiangxi Sheng',
        },
        {
            name: 'Xinzhou',
            subdivision: 'Shanxi Sheng',
        },
        {
            name: 'Xinzhou',
            subdivision: 'Hubei',
        },
        {
            name: 'Xinzhi',
            subdivision: 'Shanxi Sheng',
        },
        {
            name: 'Xinyu',
            subdivision: 'Jiangxi Sheng',
        },
        {
            name: 'Hancheng',
            subdivision: 'Henan Sheng',
        },
        {
            name: 'Xinyang',
            subdivision: 'Henan Sheng',
        },
        {
            name: 'Nangandao',
            subdivision: 'Henan Sheng',
        },
        {
            name: 'Xintai',
            subdivision: 'Shandong Sheng',
        },
        {
            name: 'Xinshi',
            subdivision: 'Hubei',
        },
        {
            name: 'Xinpu',
            subdivision: 'Jiangsu',
        },
        {
            name: 'Xinji',
            subdivision: 'Hebei',
        },
        {
            name: 'Xining',
            subdivision: 'Qinghai Sheng',
        },
        {
            name: 'Shangmei',
            subdivision: 'Hunan',
        },
        {
            name: 'Xingtai',
            subdivision: 'Hebei',
        },
        {
            name: 'Ankang',
            subdivision: 'Shaanxi',
        },
        {
            name: 'Xindian',
            subdivision: 'Shandong Sheng',
        },
        {
            name: 'Xindi',
            subdivision: 'Hubei',
        },
        {
            name: 'Feicheng',
            subdivision: 'Shandong Sheng',
        },
        {
            name: 'Sanshui',
            subdivision: 'Guangdong',
        },
        {
            name: 'Ximei',
            subdivision: 'Fujian',
        },
        {
            name: 'Wacheng',
            subdivision: 'Henan Sheng',
        },
        {
            name: 'Xihe',
            subdivision: 'Hubei',
        },
        {
            name: 'Xichang',
            subdivision: 'Sichuan',
        },
        {
            name: 'Xiazhuang',
            subdivision: 'Shandong Sheng',
        },
        {
            name: 'Xiazhen',
            subdivision: 'Shandong Sheng',
        },
        {
            name: 'Xiashi',
            subdivision: 'Zhejiang Sheng',
        },
        {
            name: 'Zijinglu',
            subdivision: 'Henan Sheng',
        },
        {
            name: 'Xiaoweizhai',
            subdivision: 'Guizhou Sheng',
        },
        {
            name: 'Xiaoshan',
            subdivision: 'Zhejiang Sheng',
        },
        {
            name: 'Xiaolingwei',
            subdivision: 'Jiangsu',
        },
        {
            name: 'Xiaogan',
            subdivision: 'Hubei',
        },
        {
            name: 'Xianyang',
            subdivision: 'Shaanxi',
        },
        {
            name: 'Xiantao',
            subdivision: 'Hubei',
        },
        {
            name: 'Xianshuigu',
            subdivision: 'Tianjin Shi',
        },
        {
            name: 'Xiannü',
            subdivision: 'Jiangsu',
        },
        {
            name: 'Xianning',
            subdivision: 'Hubei',
        },
        {
            name: 'Xianju',
            subdivision: 'Zhejiang Sheng',
        },
        {
            name: 'Zhuhai',
            subdivision: 'Guangdong',
        },
        {
            name: 'Wenxing',
            subdivision: 'Hunan',
        },
        {
            name: 'Xiangxiang',
            subdivision: 'Hunan',
        },
        {
            name: 'Xiangtan',
            subdivision: 'Hunan',
        },
        {
            name: 'Xiangyang',
            subdivision: 'Hubei',
        },
        {
            name: 'Xiangcheng Chengguanzhen',
            subdivision: 'Henan Sheng',
        },
        {
            name: 'Xi’an',
            subdivision: 'Shaanxi',
        },
        {
            name: 'Xiamen',
            subdivision: 'Fujian',
        },
        {
            name: 'Wuzhou',
            subdivision: 'Guangxi Zhuangzu Zizhiqu',
        },
        {
            name: 'Wuyang',
            subdivision: 'Anhui Sheng',
        },
        {
            name: 'Wuxue',
            subdivision: 'Hubei',
        },
        {
            name: 'Wuxi',
            subdivision: 'Jiangsu',
        },
        {
            name: 'Dongyang',
            subdivision: 'Zhejiang Sheng',
        },
        {
            name: 'Changde',
            subdivision: 'Hunan',
        },
        {
            name: 'Wuhu',
            subdivision: 'Anhui Sheng',
        },
        {
            name: 'Wuhan',
            subdivision: 'Hubei',
        },
        {
            name: 'Wuhai',
            subdivision: 'Inner Mongolia',
        },
        {
            name: 'Wuda',
            subdivision: 'Inner Mongolia',
        },
        {
            name: 'Wucheng',
            subdivision: 'Anhui Sheng',
        },
        {
            name: 'Wenzhou',
            subdivision: 'Zhejiang Sheng',
        },
        {
            name: 'Wenshang',
            subdivision: 'Shandong Sheng',
        },
        {
            name: 'Wenling',
            subdivision: 'Zhejiang Sheng',
        },
        {
            name: 'Tianfu',
            subdivision: 'Shandong Sheng',
        },
        {
            name: 'Weinan',
            subdivision: 'Shaanxi',
        },
        {
            name: 'Weihai',
            subdivision: 'Shandong Sheng',
        },
        {
            name: 'Weifang',
            subdivision: 'Shandong Sheng',
        },
        {
            name: 'Wanxian',
            subdivision: 'Chongqing Shi',
        },
        {
            name: 'Wanning',
            subdivision: 'Hainan',
        },
        {
            name: 'Yinzhu',
            subdivision: 'Shandong Sheng',
        },
        {
            name: 'Wafangdian',
            subdivision: 'Liaoning',
        },
        {
            name: 'Huangshan',
            subdivision: 'Anhui Sheng',
        },
        {
            name: 'Loushanguan',
            subdivision: 'Guizhou Sheng',
        },
        {
            name: 'Tongzhou',
            subdivision: 'Beijing',
        },
        {
            name: 'Fuding',
            subdivision: 'Fujian',
        },
        {
            name: 'Tongren',
            subdivision: 'Guizhou Sheng',
        },
        {
            name: 'Wusong',
            subdivision: 'Anhui Sheng',
        },
        {
            name: 'Tongchuan',
            subdivision: 'Sichuan',
        },
        {
            name: 'Tianshui',
            subdivision: 'Gansu Sheng',
        },
        {
            name: 'Tianpeng',
            subdivision: 'Sichuan',
        },
        {
            name: 'Tianjin',
            subdivision: 'Tianjin Shi',
        },
        {
            name: 'Tengzhou',
            subdivision: 'Shandong Sheng',
        },
        {
            name: 'Taozhuang',
            subdivision: 'Shandong Sheng',
        },
        {
            name: 'Tantou',
            subdivision: 'Fujian',
        },
        {
            name: 'Tangzhai',
            subdivision: 'Anhui Sheng',
        },
        {
            name: 'Tangshan',
            subdivision: 'Hebei',
        },
        {
            name: 'Tangping',
            subdivision: 'Guangdong',
        },
        {
            name: 'Tangjiazhuang',
            subdivision: 'Hebei',
        },
        {
            name: 'Binhe',
            subdivision: 'Henan Sheng',
        },
        {
            name: 'Tanggu',
            subdivision: 'Tianjin Shi',
        },
        {
            name: 'Taizhou',
            subdivision: 'Jiangsu',
        },
        {
            name: 'Taiyuan',
            subdivision: 'Shanxi Sheng',
        },
        {
            name: 'Taixing',
            subdivision: 'Jiangsu',
        },
        {
            name: 'Taishan',
            subdivision: 'Guangdong',
        },
        {
            name: 'Tai’an',
            subdivision: 'Shandong Sheng',
        },
        {
            name: 'Suzhou',
            subdivision: 'Anhui Sheng',
        },
        {
            name: 'Suozhen',
            subdivision: 'Shandong Sheng',
        },
        {
            name: 'Suizhou',
            subdivision: 'Hubei',
        },
        {
            name: 'Suixi',
            subdivision: 'Anhui Sheng',
        },
        {
            name: 'Suicheng',
            subdivision: 'Jiangsu',
        },
        {
            name: 'Suining',
            subdivision: 'Sichuan',
        },
        {
            name: 'Songjiang',
            subdivision: 'Shanghai Shi',
        },
        {
            name: 'Sishui',
            subdivision: 'Shandong Sheng',
        },
        {
            name: 'Laixi',
            subdivision: 'Shandong Sheng',
        },
        {
            name: 'Shouguang',
            subdivision: 'Shandong Sheng',
        },
        {
            name: 'Shizuishan',
            subdivision: 'Ningxia Huizu Zizhiqu',
        },
        {
            name: 'Shizilu',
            subdivision: 'Shandong Sheng',
        },
        {
            name: 'Shiyan',
            subdivision: 'Hubei',
        },
        {
            name: 'Shiyan',
            subdivision: 'Hubei',
        },
        {
            name: 'Shiwan',
            subdivision: 'Guangdong',
        },
        {
            name: 'Shitanjing',
            subdivision: 'Ningxia Huizu Zizhiqu',
        },
        {
            name: 'Shiqiao',
            subdivision: 'Guangdong',
        },
        {
            name: 'Shiqi',
            subdivision: 'Guangdong',
        },
        {
            name: 'Shima',
            subdivision: 'Fujian',
        },
        {
            name: 'Shilong',
            subdivision: 'Guangdong',
        },
        {
            name: 'Tongchuan',
            subdivision: 'Shaanxi',
        },
        {
            name: 'Shijiazhuang',
            subdivision: 'Hebei',
        },
        {
            name: 'Shenzhen',
            subdivision: 'Guangdong',
        },
        {
            name: 'Yanta',
            subdivision: 'Shandong Sheng',
        },
        {
            name: 'Shenjiamen',
            subdivision: 'Zhejiang Sheng',
        },
        {
            name: 'Shashi',
            subdivision: 'Hubei',
        },
        {
            name: 'Shaping',
            subdivision: 'Guangdong',
        },
        {
            name: 'Shaoxing',
            subdivision: 'Zhejiang Sheng',
        },
        {
            name: 'Shaowu',
            subdivision: 'Fujian',
        },
        {
            name: 'Shaoguan',
            subdivision: 'Guangdong',
        },
        {
            name: 'Shancheng',
            subdivision: 'Shandong Sheng',
        },
        {
            name: 'Shanwei',
            subdivision: 'Guangdong',
        },
        {
            name: 'Shantou',
            subdivision: 'Guangdong',
        },
        {
            name: 'Shanting',
            subdivision: 'Shandong Sheng',
        },
        {
            name: 'Shanghai',
            subdivision: 'Shanghai Shi',
        },
        {
            name: 'Shahecheng',
            subdivision: 'Hebei',
        },
        {
            name: 'Sanya',
            subdivision: 'Hainan',
        },
        {
            name: 'Sanming',
            subdivision: 'Fujian',
        },
        {
            name: 'Runing',
            subdivision: 'Henan Sheng',
        },
        {
            name: 'Fuqing',
            subdivision: 'Fujian',
        },
        {
            name: 'Jieyang',
            subdivision: 'Guangdong',
        },
        {
            name: 'Rizhao',
            subdivision: 'Shandong Sheng',
        },
        {
            name: 'Renqiu',
            subdivision: 'Hebei',
        },
        {
            name: 'Quzhou',
            subdivision: 'Zhejiang Sheng',
        },
        {
            name: 'Qujing',
            subdivision: 'Yunnan',
        },
        {
            name: 'Qufu',
            subdivision: 'Shandong Sheng',
        },
        {
            name: 'Quanzhou',
            subdivision: 'Fujian',
        },
        {
            name: 'Wuxi',
            subdivision: 'Hunan',
        },
        {
            name: 'Zhuangyuan',
            subdivision: 'Shandong Sheng',
        },
        {
            name: 'Qiongshan',
            subdivision: 'Hainan',
        },
        {
            name: 'Qionghu',
            subdivision: 'Hunan',
        },
        {
            name: 'Qinzhou',
            subdivision: 'Guangxi Zhuangzu Zizhiqu',
        },
        {
            name: 'Qinnan',
            subdivision: 'Jiangsu',
        },
        {
            name: 'Qinhuangdao',
            subdivision: 'Hebei',
        },
        {
            name: 'Jinjiang',
            subdivision: 'Fujian',
        },
        {
            name: 'Qingquan',
            subdivision: 'Hubei',
        },
        {
            name: "Huai'an",
            subdivision: 'Jiangsu',
        },
        {
            name: 'Qingdao',
            subdivision: 'Shandong Sheng',
        },
        {
            name: 'Qingyuan',
            subdivision: 'Guangdong',
        },
        {
            name: 'Hongqiao',
            subdivision: 'Hunan',
        },
        {
            name: 'Puyang Chengguanzhen',
            subdivision: 'Henan Sheng',
        },
        {
            name: 'Puyang',
            subdivision: 'Zhejiang Sheng',
        },
        {
            name: 'Putian',
            subdivision: 'Fujian',
        },
        {
            name: 'Puqi',
            subdivision: 'Hubei',
        },
        {
            name: 'Pumiao',
            subdivision: 'Guangxi Zhuangzu Zizhiqu',
        },
        {
            name: 'Pulandian',
            subdivision: 'Liaoning',
        },
        {
            name: 'Poyang',
            subdivision: 'Jiangxi Sheng',
        },
        {
            name: 'Pingyin',
            subdivision: 'Shandong Sheng',
        },
        {
            name: 'Pingyi',
            subdivision: 'Shandong Sheng',
        },
        {
            name: 'Gutao',
            subdivision: 'Shanxi Sheng',
        },
        {
            name: 'Pingxiang',
            subdivision: 'Jiangxi Sheng',
        },
        {
            name: 'Pingshan',
            subdivision: 'Guangdong',
        },
        {
            name: 'Pingnan',
            subdivision: 'Guangxi Zhuangzu Zizhiqu',
        },
        {
            name: 'Pingliang',
            subdivision: 'Gansu Sheng',
        },
        {
            name: 'Pingdu',
            subdivision: 'Shandong Sheng',
        },
        {
            name: 'Pingdingshan',
            subdivision: 'Henan Sheng',
        },
        {
            name: 'Pengcheng',
            subdivision: 'Hebei',
        },
        {
            name: 'Dadukou',
            subdivision: 'Sichuan',
        },
        {
            name: 'Ningyang',
            subdivision: 'Shandong Sheng',
        },
        {
            name: 'Yutan',
            subdivision: 'Hunan',
        },
        {
            name: 'Ninghai',
            subdivision: 'Shandong Sheng',
        },
        {
            name: 'Ninghai',
            subdivision: 'Zhejiang Sheng',
        },
        {
            name: 'Ningbo',
            subdivision: 'Zhejiang Sheng',
        },
        {
            name: 'Neijiang',
            subdivision: 'Sichuan',
        },
        {
            name: 'Nanzhou',
            subdivision: 'Hunan',
        },
        {
            name: 'Nanzhang Chengguanzhen',
            subdivision: 'Hubei',
        },
        {
            name: 'Nanyang',
            subdivision: 'Henan Sheng',
        },
        {
            name: 'Nantong',
            subdivision: 'Jiangsu',
        },
        {
            name: 'Pucheng',
            subdivision: 'Fujian',
        },
        {
            name: 'Nanping',
            subdivision: 'Fujian',
        },
        {
            name: 'Nanning',
            subdivision: 'Guangxi Zhuangzu Zizhiqu',
        },
        {
            name: 'Nanma',
            subdivision: 'Shandong Sheng',
        },
        {
            name: 'Nanlong',
            subdivision: 'Sichuan',
        },
        {
            name: 'Nanjing',
            subdivision: 'Jiangsu',
        },
        {
            name: 'Nangong',
            subdivision: 'Hebei',
        },
        {
            name: 'Nanfeng',
            subdivision: 'Guangdong',
        },
        {
            name: 'Nandu',
            subdivision: 'Guangxi Zhuangzu Zizhiqu',
        },
        {
            name: 'Nanding',
            subdivision: 'Shandong Sheng',
        },
        {
            name: 'Nanchong',
            subdivision: 'Sichuan',
        },
        {
            name: 'Nanchang',
            subdivision: 'Jiangxi Sheng',
        },
        {
            name: 'Miyang',
            subdivision: 'Yunnan',
        },
        {
            name: 'Mingshui',
            subdivision: 'Shandong Sheng',
        },
        {
            name: 'Mingguang',
            subdivision: 'Anhui Sheng',
        },
        {
            name: 'Minggang',
            subdivision: 'Henan Sheng',
        },
        {
            name: 'Mianyang',
            subdivision: 'Sichuan',
        },
        {
            name: 'Mentougou',
            subdivision: 'Beijing',
        },
        {
            name: 'Mengyin',
            subdivision: 'Shandong Sheng',
        },
        {
            name: 'Mengcheng Chengguanzhen',
            subdivision: 'Anhui Sheng',
        },
        {
            name: 'Meizhou',
            subdivision: 'Guangdong',
        },
        {
            name: 'Wuchuan',
            subdivision: 'Guangdong',
        },
        {
            name: 'Majie',
            subdivision: 'Yunnan',
        },
        {
            name: 'Zhijiang',
            subdivision: 'Hubei',
        },
        {
            name: 'Macheng',
            subdivision: 'Hubei',
        },
        {
            name: 'Maba',
            subdivision: 'Guangdong',
        },
        {
            name: 'Lüshun',
            subdivision: 'Liaoning',
        },
        {
            name: 'Luqiao',
            subdivision: 'Zhejiang Sheng',
        },
        {
            name: 'Luoyang',
            subdivision: 'Henan Sheng',
        },
        {
            name: 'Luoyang',
            subdivision: 'Fujian',
        },
        {
            name: 'Luoyang',
            subdivision: 'Guangdong',
        },
        {
            name: 'Luorong',
            subdivision: 'Guangxi Zhuangzu Zizhiqu',
        },
        {
            name: 'Luohe',
            subdivision: 'Henan Sheng',
        },
        {
            name: 'Luocheng',
            subdivision: 'Sichuan',
        },
        {
            name: 'Lucheng',
            subdivision: 'Anhui Sheng',
        },
        {
            name: 'Kangding',
            subdivision: 'Sichuan',
        },
        {
            name: 'Lubu',
            subdivision: 'Guangdong',
        },
        {
            name: 'Luancheng',
            subdivision: 'Hebei',
        },
        {
            name: 'Loudi',
            subdivision: 'Hunan',
        },
        {
            name: 'Longquan',
            subdivision: 'Yunnan',
        },
        {
            name: 'Longgang',
            subdivision: 'Shandong Sheng',
        },
        {
            name: 'Licheng',
            subdivision: 'Jiangsu',
        },
        {
            name: 'Guankou',
            subdivision: 'Hunan',
        },
        {
            name: 'Puning',
            subdivision: 'Guangdong',
        },
        {
            name: 'Lishui',
            subdivision: 'Zhejiang Sheng',
        },
        {
            name: 'Lintong',
            subdivision: 'Shaanxi',
        },
        {
            name: 'Linyi',
            subdivision: 'Shandong Sheng',
        },
        {
            name: 'Linxia Chengguanzhen',
            subdivision: 'Gansu Sheng',
        },
        {
            name: 'Linxi',
            subdivision: 'Hebei',
        },
        {
            name: 'Linshui',
            subdivision: 'Hebei',
        },
        {
            name: 'Linqu',
            subdivision: 'Shandong Sheng',
        },
        {
            name: 'Linqiong',
            subdivision: 'Sichuan',
        },
        {
            name: 'Qingnian',
            subdivision: 'Shandong Sheng',
        },
        {
            name: 'Linping',
            subdivision: 'Zhejiang Sheng',
        },
        {
            name: 'Linhai',
            subdivision: 'Zhejiang Sheng',
        },
        {
            name: 'Lingcheng',
            subdivision: 'Guangxi Zhuangzu Zizhiqu',
        },
        {
            name: 'Lincheng',
            subdivision: 'Hainan',
        },
        {
            name: 'Linfen',
            subdivision: 'Shanxi Sheng',
        },
        {
            name: 'Xishan',
            subdivision: 'Hunan',
        },
        {
            name: 'Lichuan',
            subdivision: 'Hubei',
        },
        {
            name: 'Licheng',
            subdivision: 'Guangdong',
        },
        {
            name: 'Liaocheng',
            subdivision: 'Shandong Sheng',
        },
        {
            name: 'Lianzhou',
            subdivision: 'Guangdong',
        },
        {
            name: 'Lianzhou',
            subdivision: 'Guangxi Zhuangzu Zizhiqu',
        },
        {
            name: 'Lianran',
            subdivision: 'Yunnan',
        },
        {
            name: 'Wuwei',
            subdivision: 'Gansu Sheng',
        },
        {
            name: 'Liangxiang',
            subdivision: 'Beijing',
        },
        {
            name: 'Lianjiang',
            subdivision: 'Guangdong',
        },
        {
            name: 'Leshan',
            subdivision: 'Sichuan',
        },
        {
            name: 'Lengshuitan',
            subdivision: 'Hunan',
        },
        {
            name: 'Lengshuijiang',
            subdivision: 'Hunan',
        },
        {
            name: 'Leiyang',
            subdivision: 'Hunan',
        },
        {
            name: 'Lecheng',
            subdivision: 'Guangdong',
        },
        {
            name: 'Laohekou',
            subdivision: 'Hubei',
        },
        {
            name: 'Lanzhou',
            subdivision: 'Gansu Sheng',
        },
        {
            name: 'Lanxi',
            subdivision: 'Zhejiang Sheng',
        },
        {
            name: 'Lianyuan',
            subdivision: 'Hunan',
        },
        {
            name: 'Langfang',
            subdivision: 'Hebei',
        },
        {
            name: 'Weichanglu',
            subdivision: 'Shandong Sheng',
        },
        {
            name: 'Laiyang',
            subdivision: 'Shandong Sheng',
        },
        {
            name: 'Laiwu',
            subdivision: 'Shandong Sheng',
        },
        {
            name: 'Laibin',
            subdivision: 'Guangxi Zhuangzu Zizhiqu',
        },
        {
            name: 'Kunyang',
            subdivision: 'Zhejiang Sheng',
        },
        {
            name: 'Kunming',
            subdivision: 'Yunnan',
        },
        {
            name: 'Kaiyuan',
            subdivision: 'Yunnan',
        },
        {
            name: 'Kaihua',
            subdivision: 'Yunnan',
        },
        {
            name: 'Kaifeng',
            subdivision: 'Henan Sheng',
        },
        {
            name: 'Juye',
            subdivision: 'Shandong Sheng',
        },
        {
            name: 'Juegang',
            subdivision: 'Jiangsu',
        },
        {
            name: 'Jiujiang',
            subdivision: 'Jiangxi Sheng',
        },
        {
            name: 'Jishui',
            subdivision: 'Henan Sheng',
        },
        {
            name: 'Qianzhou',
            subdivision: 'Hunan',
        },
        {
            name: 'Jinzhou',
            subdivision: 'Liaoning',
        },
        {
            name: 'Jinxiang',
            subdivision: 'Zhejiang Sheng',
        },
        {
            name: 'Jinshi',
            subdivision: 'Hunan',
        },
        {
            name: 'Jinsha',
            subdivision: 'Jiangsu',
        },
        {
            name: 'Jinjiang',
            subdivision: 'Hainan',
        },
        {
            name: 'Jinji',
            subdivision: 'Guangxi Zhuangzu Zizhiqu',
        },
        {
            name: 'Jining',
            subdivision: 'Shandong Sheng',
        },
        {
            name: 'Jinhua',
            subdivision: 'Zhejiang Sheng',
        },
        {
            name: 'Jingzhou',
            subdivision: 'Hubei',
        },
        {
            name: 'Tianchang',
            subdivision: 'Hebei',
        },
        {
            name: 'Jingmen',
            subdivision: 'Hubei',
        },
        {
            name: 'Jingling',
            subdivision: 'Hubei',
        },
        {
            name: 'Jingdezhen',
            subdivision: 'Jiangxi Sheng',
        },
        {
            name: 'Jinchang',
            subdivision: 'Gansu Sheng',
        },
        {
            name: 'Jincheng',
            subdivision: 'Shanxi Sheng',
        },
        {
            name: 'Jinan',
            subdivision: 'Shandong Sheng',
        },
        {
            name: 'Jimo',
            subdivision: 'Shandong Sheng',
        },
        {
            name: 'Jijiang',
            subdivision: 'Chongqing Shi',
        },
        {
            name: 'Jiexiu',
            subdivision: 'Shanxi Sheng',
        },
        {
            name: 'Jieshou',
            subdivision: 'Anhui Sheng',
        },
        {
            name: 'Jieshi',
            subdivision: 'Guangdong',
        },
        {
            name: 'Jiehu',
            subdivision: 'Shandong Sheng',
        },
        {
            name: 'Jiazi',
            subdivision: 'Guangdong',
        },
        {
            name: 'Jiaxing',
            subdivision: 'Zhejiang Sheng',
        },
        {
            name: 'Jiaozuo',
            subdivision: 'Henan Sheng',
        },
        {
            name: 'Jiaozhou',
            subdivision: 'Shandong Sheng',
        },
        {
            name: 'Ningde',
            subdivision: 'Fujian',
        },
        {
            name: 'Jian’ou',
            subdivision: 'Fujian',
        },
        {
            name: 'Jiangyan',
            subdivision: 'Jiangsu',
        },
        {
            name: 'Jianguang',
            subdivision: 'Jiangxi Sheng',
        },
        {
            name: 'Jiangmen',
            subdivision: 'Guangdong',
        },
        {
            name: 'Jiangkou',
            subdivision: 'Fujian',
        },
        {
            name: 'Yangjiang',
            subdivision: 'Guangdong',
        },
        {
            name: 'Ji’an',
            subdivision: 'Jiangxi Sheng',
        },
        {
            name: 'Guangyuan',
            subdivision: 'Sichuan',
        },
        {
            name: 'Huzhou',
            subdivision: 'Zhejiang Sheng',
        },
        {
            name: 'Hutang',
            subdivision: 'Jiangsu',
        },
        {
            name: 'Huoqiu Chengguanzhen',
            subdivision: 'Anhui Sheng',
        },
        {
            name: 'Humen',
            subdivision: 'Guangdong',
        },
        {
            name: 'Huizhou',
            subdivision: 'Guangdong',
        },
        {
            name: 'Huilong',
            subdivision: 'Jiangsu',
        },
        {
            name: 'Huicheng',
            subdivision: 'Guangdong',
        },
        {
            name: 'Xinhui',
            subdivision: 'Guangdong',
        },
        {
            name: 'Huazhou',
            subdivision: 'Guangdong',
        },
        {
            name: 'Huangzhou',
            subdivision: 'Hubei',
        },
        {
            name: 'Huangyan',
            subdivision: 'Zhejiang Sheng',
        },
        {
            name: 'Huangshi',
            subdivision: 'Hubei',
        },
        {
            name: 'Dasha',
            subdivision: 'Guangdong',
        },
        {
            name: 'Huangpi',
            subdivision: 'Hubei',
        },
        {
            name: 'Huangmei',
            subdivision: 'Hubei',
        },
        {
            name: 'Huanggang',
            subdivision: 'Guangdong',
        },
        {
            name: 'Daxing',
            subdivision: 'Beijing',
        },
        {
            name: 'Dingcheng',
            subdivision: 'Henan Sheng',
        },
        {
            name: 'Huaiyuan Chengguanzhen',
            subdivision: 'Anhui Sheng',
        },
        {
            name: 'Huainan',
            subdivision: 'Anhui Sheng',
        },
        {
            name: 'Huaicheng',
            subdivision: 'Guangdong',
        },
        {
            name: 'Huaihua',
            subdivision: 'Hunan',
        },
        {
            name: 'Huaidian',
            subdivision: 'Henan Sheng',
        },
        {
            name: 'Huaibei',
            subdivision: 'Anhui Sheng',
        },
        {
            name: 'Hongjiang',
            subdivision: 'Hunan',
        },
        {
            name: 'Heze',
            subdivision: 'Shandong Sheng',
        },
        {
            name: 'Hechuan',
            subdivision: 'Chongqing Shi',
        },
        {
            name: 'Yiyang',
            subdivision: 'Hunan',
        },
        {
            name: 'Hepo',
            subdivision: 'Guangdong',
        },
        {
            name: 'Hengyang',
            subdivision: 'Hunan',
        },
        {
            name: 'Hengshui',
            subdivision: 'Hebei',
        },
        {
            name: 'Hefei',
            subdivision: 'Anhui Sheng',
        },
        {
            name: 'Hede',
            subdivision: 'Jiangsu',
        },
        {
            name: 'Hecun',
            subdivision: 'Hebei',
        },
        {
            name: 'Hebi',
            subdivision: 'Henan Sheng',
        },
        {
            name: 'Hanzhong',
            subdivision: 'Shaanxi',
        },
        {
            name: 'Chengyang',
            subdivision: 'Fujian',
        },
        {
            name: 'Hanting',
            subdivision: 'Shandong Sheng',
        },
        {
            name: 'Hangzhou',
            subdivision: 'Zhejiang Sheng',
        },
        {
            name: 'Hangu',
            subdivision: 'Tianjin Shi',
        },
        {
            name: 'Handan',
            subdivision: 'Hebei',
        },
        {
            name: 'Hanchuan',
            subdivision: 'Hubei',
        },
        {
            name: 'Hancheng',
            subdivision: 'Shaanxi',
        },
        {
            name: 'Haizhou',
            subdivision: 'Jiangsu',
        },
        {
            name: 'Jiaojiang',
            subdivision: 'Zhejiang Sheng',
        },
        {
            name: 'Haimen',
            subdivision: 'Guangdong',
        },
        {
            name: 'Haikou',
            subdivision: 'Yunnan',
        },
        {
            name: 'Haikou',
            subdivision: 'Hainan',
        },
        {
            name: 'Guye',
            subdivision: 'Hebei',
        },
        {
            name: 'Guozhen',
            subdivision: 'Shaanxi',
        },
        {
            name: 'Guli',
            subdivision: 'Zhejiang Sheng',
        },
        {
            name: 'Guiyang',
            subdivision: 'Guizhou Sheng',
        },
        {
            name: 'Guiren',
            subdivision: 'Jiangsu',
        },
        {
            name: 'Guiping',
            subdivision: 'Guangxi Zhuangzu Zizhiqu',
        },
        {
            name: 'Guilin',
            subdivision: 'Guangxi Zhuangzu Zizhiqu',
        },
        {
            name: 'Guigang',
            subdivision: 'Guangxi Zhuangzu Zizhiqu',
        },
        {
            name: 'Gucheng Chengguanzhen',
            subdivision: 'Hubei',
        },
        {
            name: 'Guangzhou',
            subdivision: 'Guangdong',
        },
        {
            name: 'Guangshui',
            subdivision: 'Hubei',
        },
        {
            name: 'Gejiu',
            subdivision: 'Yunnan',
        },
        {
            name: 'Gaozhou',
            subdivision: 'Guangdong',
        },
        {
            name: 'Gaoyou',
            subdivision: 'Jiangsu',
        },
        {
            name: 'Gaoping',
            subdivision: 'Sichuan',
        },
        {
            name: 'Gaomi',
            subdivision: 'Shandong Sheng',
        },
        {
            name: 'Gaogou',
            subdivision: 'Jiangsu',
        },
        {
            name: 'Fuzhou',
            subdivision: 'Fujian',
        },
        {
            name: 'Fuyang',
            subdivision: 'Anhui Sheng',
        },
        {
            name: 'Fuyang',
            subdivision: 'Zhejiang Sheng',
        },
        {
            name: 'Qingyang',
            subdivision: 'Shandong Sheng',
        },
        {
            name: 'Fuling',
            subdivision: 'Chongqing Shi',
        },
        {
            name: 'Foshan',
            subdivision: 'Guangdong',
        },
        {
            name: 'Fenyi',
            subdivision: 'Jiangxi Sheng',
        },
        {
            name: 'Fengxian',
            subdivision: 'Jiangsu',
        },
        {
            name: 'Fengrun',
            subdivision: 'Hebei',
        },
        {
            name: 'Fengkou',
            subdivision: 'Hubei',
        },
        {
            name: 'Feicheng',
            subdivision: 'Shandong Sheng',
        },
        {
            name: 'Fangshan',
            subdivision: 'Beijing',
        },
        {
            name: 'Ezhou',
            subdivision: 'Hubei',
        },
        {
            name: 'Enshi',
            subdivision: 'Hubei',
        },
        {
            name: 'Encheng',
            subdivision: 'Guangdong',
        },
        {
            name: 'Duyun',
            subdivision: 'Guizhou Sheng',
        },
        {
            name: 'Duobao',
            subdivision: 'Hubei',
        },
        {
            name: 'Ducheng',
            subdivision: 'Guangdong',
        },
        {
            name: 'Xinyi',
            subdivision: 'Guangdong',
        },
        {
            name: 'Shengli',
            subdivision: 'Shandong Sheng',
        },
        {
            name: 'Dongtai',
            subdivision: 'Jiangsu',
        },
        {
            name: 'Dongsheng',
            subdivision: 'Inner Mongolia',
        },
        {
            name: 'Dongkan',
            subdivision: 'Jiangsu',
        },
        {
            name: 'Donghai',
            subdivision: 'Guangdong',
        },
        {
            name: 'Dongguan',
            subdivision: 'Guangdong',
        },
        {
            name: 'Dongdu',
            subdivision: 'Shandong Sheng',
        },
        {
            name: 'Dongcun',
            subdivision: 'Shandong Sheng',
        },
        {
            name: 'Dingzhou',
            subdivision: 'Hebei',
        },
        {
            name: 'Dingtao',
            subdivision: 'Shandong Sheng',
        },
        {
            name: 'Dezhou',
            subdivision: 'Shandong Sheng',
        },
        {
            name: 'Deyang',
            subdivision: 'Sichuan',
        },
        {
            name: 'Deqing',
            subdivision: 'Zhejiang Sheng',
        },
        {
            name: 'Dengzhou',
            subdivision: 'Shandong Sheng',
        },
        {
            name: 'Huazhou',
            subdivision: 'Henan Sheng',
        },
        {
            name: 'Songyang',
            subdivision: 'Henan Sheng',
        },
        {
            name: 'Dazhong',
            subdivision: 'Jiangsu',
        },
        {
            name: 'Zhangjiajie',
            subdivision: 'Hunan',
        },
        {
            name: 'Daye',
            subdivision: 'Hubei',
        },
        {
            name: 'Lijiang',
            subdivision: 'Yunnan',
        },
        {
            name: 'Dazhou',
            subdivision: 'Sichuan',
        },
        {
            name: 'Dawukou',
            subdivision: 'Ningxia Huizu Zizhiqu',
        },
        {
            name: 'Datong',
            subdivision: 'Anhui Sheng',
        },
        {
            name: 'Fenghua',
            subdivision: 'Zhejiang Sheng',
        },
        {
            name: 'Daokou',
            subdivision: 'Henan Sheng',
        },
        {
            name: 'Danshui',
            subdivision: 'Guangdong',
        },
        {
            name: 'Danjiangkou',
            subdivision: 'Hubei',
        },
        {
            name: 'Gushu',
            subdivision: 'Anhui Sheng',
        },
        {
            name: 'Xincheng',
            subdivision: 'Henan Sheng',
        },
        {
            name: 'Daliang',
            subdivision: 'Guangdong',
        },
        {
            name: 'Dalian',
            subdivision: 'Liaoning',
        },
        {
            name: 'Dali',
            subdivision: 'Yunnan',
        },
        {
            name: 'Chuzhou',
            subdivision: 'Anhui Sheng',
        },
        {
            name: 'Yangchun',
            subdivision: 'Guangdong',
        },
        {
            name: 'Yiwu',
            subdivision: 'Zhejiang Sheng',
        },
        {
            name: 'Chongqing',
            subdivision: 'Chongqing Shi',
        },
        {
            name: 'Chonglong',
            subdivision: 'Sichuan',
        },
        {
            name: 'Chizhou',
            subdivision: 'Anhui Sheng',
        },
        {
            name: 'Chenzhou',
            subdivision: 'Hunan',
        },
        {
            name: 'Chengyang',
            subdivision: 'Shandong Sheng',
        },
        {
            name: 'Jiangyin',
            subdivision: 'Jiangsu',
        },
        {
            name: 'Chengdu',
            subdivision: 'Sichuan',
        },
        {
            name: 'Chenghua',
            subdivision: 'Guangdong',
        },
        {
            name: 'Chaozhou',
            subdivision: 'Guangdong',
        },
        {
            name: 'Chaohu',
            subdivision: 'Anhui Sheng',
        },
        {
            name: 'Changzhou',
            subdivision: 'Jiangsu',
        },
        {
            name: 'Changzhi',
            subdivision: 'Shanxi Sheng',
        },
        {
            name: 'Changsha',
            subdivision: 'Hunan',
        },
        {
            name: 'Changqing',
            subdivision: 'Shandong Sheng',
        },
        {
            name: 'Changli',
            subdivision: 'Hebei',
        },
        {
            name: 'Changleng',
            subdivision: 'Jiangxi Sheng',
        },
        {
            name: 'Caohe',
            subdivision: 'Hubei',
        },
        {
            name: 'Weining',
            subdivision: 'Guizhou Sheng',
        },
        {
            name: 'Cangzhou',
            subdivision: 'Hebei',
        },
        {
            name: 'Caidian',
            subdivision: 'Hubei',
        },
        {
            name: 'Buhe',
            subdivision: 'Hubei',
        },
        {
            name: 'Bozhou',
            subdivision: 'Anhui Sheng',
        },
        {
            name: 'Botou',
            subdivision: 'Hebei',
        },
        {
            name: 'Boshan',
            subdivision: 'Shandong Sheng',
        },
        {
            name: 'Baise City',
            subdivision: 'Guangxi Zhuangzu Zizhiqu',
        },
        {
            name: 'Binzhou',
            subdivision: 'Shandong Sheng',
        },
        {
            name: 'Luxu',
            subdivision: 'Guangxi Zhuangzu Zizhiqu',
        },
        {
            name: 'Bijie',
            subdivision: 'Guizhou Sheng',
        },
        {
            name: 'Bianzhuang',
            subdivision: 'Shandong Sheng',
        },
        {
            name: 'Bengbu',
            subdivision: 'Anhui Sheng',
        },
        {
            name: 'Beijing',
            subdivision: 'Beijing',
        },
        {
            name: 'Beihai',
            subdivision: 'Guangxi Zhuangzu Zizhiqu',
        },
        {
            name: 'Beidao',
            subdivision: 'Gansu Sheng',
        },
        {
            name: 'Beidaihehaibin',
            subdivision: 'Hebei',
        },
        {
            name: 'Beibei',
            subdivision: 'Chongqing Shi',
        },
        {
            name: 'Baoying',
            subdivision: 'Jiangsu',
        },
        {
            name: 'Langzhong',
            subdivision: 'Sichuan',
        },
        {
            name: 'Baoding',
            subdivision: 'Hebei',
        },
        {
            name: 'Baiyin',
            subdivision: 'Gansu Sheng',
        },
        {
            name: 'Baihe',
            subdivision: 'Guangxi Zhuangzu Zizhiqu',
        },
        {
            name: 'Shangyu',
            subdivision: 'Zhejiang Sheng',
        },
        {
            name: 'Babu',
            subdivision: 'Guangxi Zhuangzu Zizhiqu',
        },
        {
            name: 'Anxiang',
            subdivision: 'Hunan',
        },
        {
            name: 'Anshun',
            subdivision: 'Guizhou Sheng',
        },
        {
            name: 'Anqiu',
            subdivision: 'Shandong Sheng',
        },
        {
            name: 'Anqing',
            subdivision: 'Anhui Sheng',
        },
        {
            name: 'Mabai',
            subdivision: 'Yunnan',
        },
        {
            name: 'Anlu',
            subdivision: 'Hubei',
        },
        {
            name: 'Anjiang',
            subdivision: 'Hunan',
        },
        {
            name: 'Anbu',
            subdivision: 'Guangdong',
        },
        {
            name: 'Jiangyou',
            subdivision: 'Sichuan',
        },
        {
            name: 'Suzhou',
            subdivision: 'Jiangsu',
        },
        {
            name: 'Zhoushan',
            subdivision: 'Zhejiang Sheng',
        },
        {
            name: 'Mudu',
            subdivision: 'Jiangsu',
        },
        {
            name: 'Songling',
            subdivision: 'Jiangsu',
        },
        {
            name: 'Zhongshan',
            subdivision: 'Guangdong',
        },
        {
            name: 'Lianghu',
            subdivision: 'Zhejiang Sheng',
        },
        {
            name: 'Zhoucheng',
            subdivision: 'Shandong Sheng',
        },
        {
            name: 'Dalianwan',
            subdivision: 'Liaoning',
        },
        {
            name: 'Yueyang',
            subdivision: 'Hunan',
        },
        {
            name: 'Bojia',
            subdivision: 'Hunan',
        },
        {
            name: 'Zhenlai',
            subdivision: 'Jilin Sheng',
        },
        {
            name: 'Zhengjiatun',
            subdivision: 'Jilin Sheng',
        },
        {
            name: 'Zhaozhou',
            subdivision: 'Heilongjiang Sheng',
        },
        {
            name: 'Zhaoyuan',
            subdivision: 'Heilongjiang Sheng',
        },
        {
            name: 'Zhaodong',
            subdivision: 'Heilongjiang Sheng',
        },
        {
            name: 'Zhangjiakou',
            subdivision: 'Hebei',
        },
        {
            name: 'Zalantun',
            subdivision: 'Inner Mongolia',
        },
        {
            name: 'Yushu',
            subdivision: 'Jilin Sheng',
        },
        {
            name: 'Youhao',
            subdivision: 'Heilongjiang Sheng',
        },
        {
            name: 'Yingkou',
            subdivision: 'Liaoning',
        },
        {
            name: 'Yilan',
            subdivision: 'Heilongjiang Sheng',
        },
        {
            name: 'Yichun',
            subdivision: 'Heilongjiang Sheng',
        },
        {
            name: 'Yebaishou',
            subdivision: 'Liaoning',
        },
        {
            name: 'Yantongshan',
            subdivision: 'Jilin Sheng',
        },
        {
            name: 'Yanji',
            subdivision: 'Jilin Sheng',
        },
        {
            name: 'Yakeshi',
            subdivision: 'Inner Mongolia',
        },
        {
            name: 'Zhangjiakou Shi Xuanhua Qu',
            subdivision: 'Hebei',
        },
        {
            name: 'Xiuyan',
            subdivision: 'Liaoning',
        },
        {
            name: 'Xinqing',
            subdivision: 'Heilongjiang Sheng',
        },
        {
            name: 'Xinmin',
            subdivision: 'Liaoning',
        },
        {
            name: 'Xinglongshan',
            subdivision: 'Jilin Sheng',
        },
        {
            name: 'Xingcheng',
            subdivision: 'Liaoning',
        },
        {
            name: 'Xilin Hot',
            subdivision: 'Inner Mongolia',
        },
        {
            name: 'Xifeng',
            subdivision: 'Liaoning',
        },
        {
            name: 'Xiaoshi',
            subdivision: 'Liaoning',
        },
        {
            name: 'Wuchang',
            subdivision: 'Heilongjiang Sheng',
        },
        {
            name: 'Wangqing',
            subdivision: 'Jilin Sheng',
        },
        {
            name: 'Hepingjie',
            subdivision: 'Jilin Sheng',
        },
        {
            name: 'Wangkui',
            subdivision: 'Heilongjiang Sheng',
        },
        {
            name: 'Ulanhot',
            subdivision: 'Inner Mongolia',
        },
        {
            name: 'Tumen',
            subdivision: 'Jilin Sheng',
        },
        {
            name: 'Tongliao',
            subdivision: 'Inner Mongolia',
        },
        {
            name: 'Tieling',
            subdivision: 'Liaoning',
        },
        {
            name: 'Tieli',
            subdivision: 'Heilongjiang Sheng',
        },
        {
            name: 'Guangming',
            subdivision: 'Jilin Sheng',
        },
        {
            name: 'Tailai',
            subdivision: 'Heilongjiang Sheng',
        },
        {
            name: 'Taikang',
            subdivision: 'Heilongjiang Sheng',
        },
        {
            name: 'Tahe',
            subdivision: 'Heilongjiang Sheng',
        },
        {
            name: 'Sujiatun',
            subdivision: 'Liaoning',
        },
        {
            name: 'Suileng',
            subdivision: 'Heilongjiang Sheng',
        },
        {
            name: 'Suihua',
            subdivision: 'Heilongjiang Sheng',
        },
        {
            name: 'Suifenhe',
            subdivision: 'Heilongjiang Sheng',
        },
        {
            name: 'Songjianghe',
            subdivision: 'Jilin Sheng',
        },
        {
            name: 'Siping',
            subdivision: 'Jilin Sheng',
        },
        {
            name: 'Shunyi',
            subdivision: 'Beijing',
        },
        {
            name: 'Shulan',
            subdivision: 'Jilin Sheng',
        },
        {
            name: 'Shuangyashan',
            subdivision: 'Heilongjiang Sheng',
        },
        {
            name: 'Shuangyang',
            subdivision: 'Jilin Sheng',
        },
        {
            name: 'Shuangcheng',
            subdivision: 'Heilongjiang Sheng',
        },
        {
            name: 'Shiguai',
            subdivision: 'Inner Mongolia',
        },
        {
            name: 'Shenyang',
            subdivision: 'Liaoning',
        },
        {
            name: 'Shanhetun',
            subdivision: 'Heilongjiang Sheng',
        },
        {
            name: 'Shanhaiguan',
            subdivision: 'Hebei',
        },
        {
            name: 'Shangzhi',
            subdivision: 'Heilongjiang Sheng',
        },
        {
            name: 'Sanchazi',
            subdivision: 'Jilin Sheng',
        },
        {
            name: 'Salaqi',
            subdivision: 'Inner Mongolia',
        },
        {
            name: 'Fendou',
            subdivision: 'Heilongjiang Sheng',
        },
        {
            name: 'Taihe',
            subdivision: 'Heilongjiang Sheng',
        },
        {
            name: 'Qiqihar',
            subdivision: 'Heilongjiang Sheng',
        },
        {
            name: 'Qinggang',
            subdivision: 'Heilongjiang Sheng',
        },
        {
            name: 'Qianguo',
            subdivision: 'Jilin Sheng',
        },
        {
            name: 'Pingzhuang',
            subdivision: 'Inner Mongolia',
        },
        {
            name: 'Panshi',
            subdivision: 'Jilin Sheng',
        },
        {
            name: 'Panshan',
            subdivision: 'Liaoning',
        },
        {
            name: 'Nianzishan',
            subdivision: 'Heilongjiang Sheng',
        },
        {
            name: 'Nenjiang',
            subdivision: 'Heilongjiang Sheng',
        },
        {
            name: 'Nehe',
            subdivision: 'Heilongjiang Sheng',
        },
        {
            name: 'Nantai',
            subdivision: 'Liaoning',
        },
        {
            name: 'Nanpiao',
            subdivision: 'Liaoning',
        },
        {
            name: 'Lianhe',
            subdivision: 'Heilongjiang Sheng',
        },
        {
            name: 'Mujiayingzi',
            subdivision: 'Inner Mongolia',
        },
        {
            name: 'Mudanjiang',
            subdivision: 'Heilongjiang Sheng',
        },
        {
            name: 'Mishan',
            subdivision: 'Heilongjiang Sheng',
        },
        {
            name: 'Mingyue',
            subdivision: 'Jilin Sheng',
        },
        {
            name: 'Mingshui',
            subdivision: 'Heilongjiang Sheng',
        },
        {
            name: 'Meihekou',
            subdivision: 'Jilin Sheng',
        },
        {
            name: 'Manzhouli',
            subdivision: 'Inner Mongolia',
        },
        {
            name: 'Longjing',
            subdivision: 'Jilin Sheng',
        },
        {
            name: 'Longjiang',
            subdivision: 'Heilongjiang Sheng',
        },
        {
            name: 'Longfeng',
            subdivision: 'Heilongjiang Sheng',
        },
        {
            name: 'Liuhe',
            subdivision: 'Jilin Sheng',
        },
        {
            name: 'Lishu',
            subdivision: 'Jilin Sheng',
        },
        {
            name: 'Linkou',
            subdivision: 'Heilongjiang Sheng',
        },
        {
            name: 'Linjiang',
            subdivision: 'Jilin Sheng',
        },
        {
            name: 'Lingyuan',
            subdivision: 'Liaoning',
        },
        {
            name: 'Lingdong',
            subdivision: 'Heilongjiang Sheng',
        },
        {
            name: 'Liaozhong',
            subdivision: 'Liaoning',
        },
        {
            name: 'Liaoyuan',
            subdivision: 'Jilin Sheng',
        },
        {
            name: 'Liaoyang',
            subdivision: 'Liaoning',
        },
        {
            name: 'Lanxi',
            subdivision: 'Heilongjiang Sheng',
        },
        {
            name: 'Langxiang',
            subdivision: 'Heilongjiang Sheng',
        },
        {
            name: 'Langtou',
            subdivision: 'Liaoning',
        },
        {
            name: 'Kuandian',
            subdivision: 'Liaoning',
        },
        {
            name: 'Kaiyuan',
            subdivision: 'Liaoning',
        },
        {
            name: 'Kaitong',
            subdivision: 'Jilin Sheng',
        },
        {
            name: 'Jixi',
            subdivision: 'Heilongjiang Sheng',
        },
        {
            name: 'Jiutai',
            subdivision: 'Jilin Sheng',
        },
        {
            name: 'Jiupu',
            subdivision: 'Liaoning',
        },
        {
            name: 'Jishu',
            subdivision: 'Jilin Sheng',
        },
        {
            name: 'Jinzhou',
            subdivision: 'Liaoning',
        },
        {
            name: 'Lianshan',
            subdivision: 'Liaoning',
        },
        {
            name: 'Jining',
            subdivision: 'Inner Mongolia',
        },
        {
            name: 'Jilin',
            subdivision: 'Jilin Sheng',
        },
        {
            name: 'Jidong',
            subdivision: 'Heilongjiang Sheng',
        },
        {
            name: 'Minzhu',
            subdivision: 'Jilin Sheng',
        },
        {
            name: 'Jiamusi',
            subdivision: 'Heilongjiang Sheng',
        },
        {
            name: 'Jalai Nur',
            subdivision: 'Inner Mongolia',
        },
        {
            name: 'Jagdaqi',
            subdivision: 'Inner Mongolia',
        },
        {
            name: 'Hushitai',
            subdivision: 'Liaoning',
        },
        {
            name: 'Hunchun',
            subdivision: 'Jilin Sheng',
        },
        {
            name: 'Hulan Ergi',
            subdivision: 'Heilongjiang Sheng',
        },
        {
            name: 'Hulan',
            subdivision: 'Heilongjiang Sheng',
        },
        {
            name: 'Huinan',
            subdivision: 'Jilin Sheng',
        },
        {
            name: 'Huanren',
            subdivision: 'Liaoning',
        },
        {
            name: 'Huangnihe',
            subdivision: 'Jilin Sheng',
        },
        {
            name: 'Huanan',
            subdivision: 'Heilongjiang Sheng',
        },
        {
            name: 'Huadian',
            subdivision: 'Jilin Sheng',
        },
        {
            name: 'Honggang',
            subdivision: 'Heilongjiang Sheng',
        },
        {
            name: 'Hohhot',
            subdivision: 'Inner Mongolia',
        },
        {
            name: 'Fendou',
            subdivision: 'Heilongjiang Sheng',
        },
        {
            name: 'Helong',
            subdivision: 'Jilin Sheng',
        },
        {
            name: 'Heishan',
            subdivision: 'Liaoning',
        },
        {
            name: 'Heihe',
            subdivision: 'Heilongjiang Sheng',
        },
        {
            name: 'Hegang',
            subdivision: 'Heilongjiang Sheng',
        },
        {
            name: 'Harbin',
            subdivision: 'Heilongjiang Sheng',
        },
        {
            name: 'Hailun',
            subdivision: 'Heilongjiang Sheng',
        },
        {
            name: 'Hailin',
            subdivision: 'Heilongjiang Sheng',
        },
        {
            name: 'Hailar',
            subdivision: 'Inner Mongolia',
        },
        {
            name: 'Haicheng',
            subdivision: 'Liaoning',
        },
        {
            name: 'Gongzhuling',
            subdivision: 'Jilin Sheng',
        },
        {
            name: 'Gongchangling',
            subdivision: 'Liaoning',
        },
        {
            name: 'Genhe',
            subdivision: 'Inner Mongolia',
        },
        {
            name: 'Gannan',
            subdivision: 'Heilongjiang Sheng',
        },
        {
            name: 'Fuyuan',
            subdivision: 'Heilongjiang Sheng',
        },
        {
            name: 'Fuyu',
            subdivision: 'Heilongjiang Sheng',
        },
        {
            name: 'Fuyu',
            subdivision: 'Jilin Sheng',
        },
        {
            name: 'Fuxin',
            subdivision: 'Liaoning',
        },
        {
            name: 'Fuxin',
            subdivision: 'Liaoning',
        },
        {
            name: 'Fushun',
            subdivision: 'Liaoning',
        },
        {
            name: 'Fuli',
            subdivision: 'Heilongjiang Sheng',
        },
        {
            name: 'Fujin',
            subdivision: 'Heilongjiang Sheng',
        },
        {
            name: 'Beichengqu',
            subdivision: 'Inner Mongolia',
        },
        {
            name: 'Fengxiang',
            subdivision: 'Heilongjiang Sheng',
        },
        {
            name: 'Fengcheng',
            subdivision: 'Liaoning',
        },
        {
            name: 'Erenhot',
            subdivision: 'Inner Mongolia',
        },
        {
            name: 'Erdaojiang',
            subdivision: 'Jilin Sheng',
        },
        {
            name: 'Dunhua',
            subdivision: 'Jilin Sheng',
        },
        {
            name: 'Dongning',
            subdivision: 'Heilongjiang Sheng',
        },
        {
            name: 'Dongling',
            subdivision: 'Liaoning',
        },
        {
            name: 'Dongfeng',
            subdivision: 'Jilin Sheng',
        },
        {
            name: 'Dongxing',
            subdivision: 'Heilongjiang Sheng',
        },
        {
            name: 'Dehui',
            subdivision: 'Jilin Sheng',
        },
        {
            name: 'Datong',
            subdivision: 'Shanxi Sheng',
        },
        {
            name: 'Dashitou',
            subdivision: 'Jilin Sheng',
        },
        {
            name: 'Dashiqiao',
            subdivision: 'Liaoning',
        },
        {
            name: 'Daqing',
            subdivision: 'Heilongjiang Sheng',
        },
        {
            name: 'Dandong',
            subdivision: 'Liaoning',
        },
        {
            name: 'Linghai',
            subdivision: 'Liaoning',
        },
        {
            name: 'Dalai',
            subdivision: 'Jilin Sheng',
        },
        {
            name: 'Chifeng',
            subdivision: 'Inner Mongolia',
        },
        {
            name: 'Chengzihe',
            subdivision: 'Heilongjiang Sheng',
        },
        {
            name: 'Chengde',
            subdivision: 'Hebei',
        },
        {
            name: 'Chaoyang',
            subdivision: 'Jilin Sheng',
        },
        {
            name: 'Chaoyang',
            subdivision: 'Liaoning',
        },
        {
            name: 'Changtu',
            subdivision: 'Liaoning',
        },
        {
            name: 'Changping',
            subdivision: 'Beijing',
        },
        {
            name: 'Changling',
            subdivision: 'Jilin Sheng',
        },
        {
            name: 'Changchun',
            subdivision: 'Jilin Sheng',
        },
        {
            name: 'Chaihe',
            subdivision: 'Heilongjiang Sheng',
        },
        {
            name: 'Boli',
            subdivision: 'Heilongjiang Sheng',
        },
        {
            name: 'Binzhou',
            subdivision: 'Heilongjiang Sheng',
        },
        {
            name: 'Benxi',
            subdivision: 'Liaoning',
        },
        {
            name: 'Beipiao',
            subdivision: 'Liaoning',
        },
        {
            name: 'Bei’an',
            subdivision: 'Heilongjiang Sheng',
        },
        {
            name: 'Bayan',
            subdivision: 'Heilongjiang Sheng',
        },
        {
            name: 'Baotou',
            subdivision: 'Inner Mongolia',
        },
        {
            name: 'Baoshan',
            subdivision: 'Heilongjiang Sheng',
        },
        {
            name: 'Baoqing',
            subdivision: 'Heilongjiang Sheng',
        },
        {
            name: 'Bamiantong',
            subdivision: 'Heilongjiang Sheng',
        },
        {
            name: 'Baishishan',
            subdivision: 'Jilin Sheng',
        },
        {
            name: 'Baiquan',
            subdivision: 'Heilongjiang Sheng',
        },
        {
            name: 'Baicheng',
            subdivision: 'Jilin Sheng',
        },
        {
            name: 'Baishan',
            subdivision: 'Jilin Sheng',
        },
        {
            name: 'Anshan',
            subdivision: 'Liaoning',
        },
        {
            name: 'Anda',
            subdivision: 'Heilongjiang Sheng',
        },
        {
            name: 'Oroqen Zizhiqi',
            subdivision: 'Inner Mongolia',
        },
        {
            name: 'Acheng',
            subdivision: 'Heilongjiang Sheng',
        },
        {
            name: 'Songling',
            subdivision: 'Hebei',
        },
        {
            name: 'Shilin',
            subdivision: 'Yunnan',
        },
        {
            name: 'Changshu City',
            subdivision: 'Jiangsu',
        },
        {
            name: 'Shixing',
            subdivision: 'Guangdong',
        },
        {
            name: 'Jiashan',
            subdivision: 'Zhejiang Sheng',
        },
        {
            name: 'Fenghuang',
            subdivision: 'Hunan',
        },
        {
            name: 'Zhu Cheng City',
            subdivision: 'Shandong Sheng',
        },
        {
            name: 'Shangri-La',
            subdivision: 'Yunnan',
        },
        {
            name: 'Ordos',
            subdivision: 'Inner Mongolia',
        },
        {
            name: 'Wenshan City',
            subdivision: 'Yunnan',
        },
        {
            name: 'Liupanshui',
            subdivision: 'Guizhou Sheng',
        },
    ],
};
//# sourceMappingURL=data:application/json;base64,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